import React, { useEffect, useState, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { Range, getTrackBackground } from 'react-range';
import { useSelector } from 'react-redux';
import { getThemeColor } from 'store/settings';
import styles from 'styles/Question.module.scss';
import Rating from '@mui/material/Rating';

export const RangeContainer = ({
  option = '',
  question,
  value = { min: 0, max: 1 },
  label = { min: '', max: '' },
  position,
  startValue = 0,
  isDisabled = false,
  questionArray,
  setQuestionArray,
  SurveyOption,
  isStarImage,
}) => {
  const [values, setValues] = useState([startValue || value.min]);
  const [starValue, setStarValue] = useState(startValue || 0);
  const { watch, setValue: ratingValue } = useFormContext();
  const themeStatus = useSelector(getThemeColor);
  const ratingStar = useRef();
  const [ratingStarWidth, setRatingStarWidth] = useState(0);
  useEffect(() => {
    value.min && setValues([Math.max(value.min, values[0])]);
  }, [value.min]);

  const handleAnswerValue = (answer) => {
    let array = [...questionArray];
    questionArray?.forEach((element, index) => {
      if (element._id === question?._id) {
        let obj = { ...element };
        obj.answerValue = answer;
        array.splice(index, 1, obj);
      }
      setQuestionArray(array);
    });
  };
  // Dynamic color render range circle
  const lerpColor = (color1, color2, t) => {
    const r = Math.round(color1[0] * (1 - t) + color2[0] * t);
    const g = Math.round(color1[1] * (1 - t) + color2[1] * t);
    const b = Math.round(color1[2] * (1 - t) + color2[2] * t);
    return `rgb(${r}, ${g}, ${b})`;
  };
  useEffect(() => {
    if (ratingStar.current) {
      setRatingStarWidth(ratingStar.current.getBoundingClientRect().width);
    }
  }, []);
  return (
    <>
      <article className="mt-1">
        <section>
          <span>{option}</span>
          <p className="font-small-5 text-secondary">
            Please select a rating on a scale of {value.min}–{value.max}, where{' '}
            {value.min} is '{label.min}' and {value.max} is '{label.max}
            '.
          </p>
          {SurveyOption == 'star' ? (
            <>
              <div
                className="d-flex justify-content-start w-50"
                style={{ pointerEvents: isStarImage ? 'none' : '' }}
              >
                <Rating
                  ref={ratingStar}
                  className="survey_rating_star_size"
                  onChange={(event, newValue) => {
                    const existingArray = new Map(watch('ratings'));
                    setStarValue(newValue);
                    existingArray.set(position, {
                      option,
                      label,
                      SurveyOption,
                      answer: newValue,
                      value,
                    });
                    ratingValue('ratings', existingArray);
                    questionArray?.length && handleAnswerValue(existingArray);
                  }}
                  value={starValue?.length == 0 ? null : starValue}
                />
              </div>
            </>
          ) : (
            <div className="mx-auto px-auto" style={{ width: '96%' }}>
              <Range
                disabled={isDisabled}
                values={values[0] > value.max ? [value.max] : values}
                step={1}
                min={value.min}
                max={value.max}
                onChange={(newValues) => {
                  const exitingArray = new Map(watch('ratings'));
                  setValues(newValues);
                  exitingArray.set(position, {
                    option,
                    label,
                    SurveyOption,
                    answer: newValues[0],
                    value,
                  });
                  ratingValue('ratings', exitingArray);
                  questionArray?.length && handleAnswerValue(exitingArray);
                }}
                renderTrack={({ props, children }) => (
                  <div
                    onMouseDown={props.onMouseDown}
                    onTouchStart={props.onTouchStart}
                    style={{
                      ...props.style,
                      height: '36px',
                      display: 'flex',
                      width: '100%',
                    }}
                  >
                    <div
                      ref={props.ref}
                      className={`${styles.rating_range}`}
                      style={{
                        background: getTrackBackground({
                          values,
                          min: value.min,
                          colors: ['white', 'white'],
                          max: value?.max,
                        }),
                        alignSelf: 'center',
                      }}
                    >
                      {children}
                    </div>
                  </div>
                )}
                renderThumb={({ props, isDragged }) => {
                  const t = (values[0] - value.min) / (value.max - value.min);
                  const thumbColor = lerpColor([255, 0, 0], [0, 255, 0], t);

                  return (
                    <div
                      {...props}
                      className={`rounded-circle font-weight-bold font-small-3 text-white d-flex justify-content-center align-items-center ${styles.rating_range_circle}`}
                      style={{
                        ...props.style,
                        '--theme-color': themeStatus,
                        backgroundColor: thumbColor,
                      }}
                    >
                      {Math.floor(values[0]?.toFixed(1))}
                    </div>
                  );
                }}
              />
            </div>
          )}
        </section>
        {SurveyOption == 'star' ? (
          <section
            className="d-flex justify-content-between mt-1"
            style={{ width: ratingStarWidth }}
          >
            <span className="view-page-title">{label?.min}</span>
            <span className="view-page-title">{label?.max}</span>
          </section>
        ) : (
          <section className="d-flex justify-content-between mt-1 text-secondary">
            <span className="view-page-title">{label?.min}</span>
            <span className="view-page-title">{label?.max}</span>
          </section>
        )}
      </article>
    </>
  );
};
